<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.applicantAccountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="acceptanceEscrowDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>

          <v-col v-if="acceptanceEscrowDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.acceptanceEscrowDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.acceptanceEscrowDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @prev-btn-click="
          () =>
            leaveStep({
              stepThis: this,
              direction: StepDirection.PREV,
              step: StepName.S5,
            })
        "
        @next-btn-click="
          () =>
            leaveStep({
              stepThis: this,
              direction: StepDirection.NEXT,
              step: StepName.S5,
            })
        "
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';

export default {
  name: 'Step5',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    applicantAccountBankDetails: { ...bankDetails },
    acceptanceEscrowDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      applicantAccountBankDetails: bankDetailsValidation,
      acceptanceEscrowDetails: {
        note: {
          required: requiredIf(() => this.acceptanceEscrowDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SAABD = ServicesModule.statement.applicantAccountBankDetails;
      const SAED = ServicesModule.statement.acceptanceEscrowDetails;

      if (SAABD) {
        this.applicantAccountBankDetails = {
          ...this.applicantAccountBankDetails,
          ...SAABD,
        };
      }

      if (SAED) {
        this.acceptanceEscrowDetails = {
          ...this.acceptanceEscrowDetails,
          ...SAED,
        };
      }
    },

    assemblyModel() {
      if (!this.acceptanceEscrowDetails.hasPrivilege) {
        this.acceptanceEscrowDetails.note = null;
      }

      return {
        applicantAccountBankDetails: {
          ...this.applicantAccountBankDetails,
        },
        acceptanceEscrowDetails: {
          ...this.acceptanceEscrowDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },
  },
};
</script>
